
    /**
     * Bitwise circular shift left
     * http://en.wikipedia.org/wiki/Circular_shift
     */
    function rol(val, shift){
        return (val << shift) | (val >> (32 - shift));
    }
    module.exports = rol;




//////////////////
// WEBPACK FOOTER
// ./~/mout/number/rol.js
// module id = 1628
// module chunks = 0 1 2